<template>
    <div class="vue-country-widget" :class="{ 'is-loading':isLoading }">
        <div class="widget-wrapper" v-if="! isLoading">
            <zoa-map-wrapper
                :countries='mappedCountriesByCode'
                :event-bus="eventBus"
                :selected-country-code="selectedCountryCode"
                :mapped-countries-with-code-and-name="mappedCountriesWithCodeAndName"
                @selected="handleSelected"
            ></zoa-map-wrapper>

            <zoa-country-aside
                v-if="hasCountries"
                :event-bus="eventBus"
                :countries="countries"
                :selected-country="selectedCountry"
                :filter-text="filterText"
                :filter-title="filterTitle"
                :back-to-map="backToMap"
                :reset-filters="resetFilters"
                :countries-title="countriesTitle"
                :specialisms-title="specialismsTitle"
                :read-more-about="readMoreAbout"
                :selected-country-help-title="selectedCountryHelpTitle"
            ></zoa-country-aside>
        </div>

        <div class="country-intro-text" v-if="showIntroText && ! isLoading" v-html="introText"></div>

        <zoa-active-country-teasers
            v-if="hasSelectedCountry"
            :selected-country="selectedCountry"
            :read-more="readMore"
            :active-teaser-title="activeTeaserTitle"
        ></zoa-active-country-teasers>
    </div>
</template>

<script>
export default {
    name: "CountryWidget",

    props: [
        'introText',
        'filterText',
        'filterTitle',
        'backToMap',
        'readMore',
        'activeTeaserTitle',
        'resetFilters',
        'countriesTitle',
        'specialismsTitle',
        'readMoreAbout',
        'selectedCountryHelpTitle',
    ],

    data() {
        return {
            isLoading: false,
            countries: [],
            selectedCountryCode: null,
            eventBus: new Vue()
        }
    },

    computed: {
        mappedCountriesByCode() {
            const mappedKeys = _.mapKeys(this.countries, (country, key) => {
                return country.countrycode;
            });

            return _.forEach(mappedKeys, (value, key) => {
                return mappedKeys[key] = 1;
            });
        },

        mappedCountriesWithCodeAndName() {
            const mappedKeys = _.mapKeys(this.countries, (country, key) => {
                return country.countrycode;
            });

            return _.forEach(mappedKeys, (value, key) => {
                return mappedKeys[key] = value.name;
            });
        },

        selectedCountry() {
            return _.find(this.countries, (country) => {
                return country.countrycode === this.selectedCountryCode;
            });
        },

        hasCountries() {
            return !_.isEmpty(this.countries);
        },

        hasSelectedCountry() {
            return !_.isNil(this.selectedCountry);
        },

        showIntroText() {
            return ! _.isEmpty(this.introText) && ! this.hasSelectedCountry;
        }
    },

    mounted() {
        this.fetchData();

        this.eventBus.$on('reset-map', () => {
            this.selectedCountryCode = null;
        })
    },

    methods: {
        fetchData() {
            this.isLoading = true;

            axios.get(`/api/countries`)
                .then(response => {
                    this.countries = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.countries = [];
                })
                .finally(() => this.isLoading = false);
        },

        handleSelected(payload) {
            this.selectedCountryCode = payload;

            if (!_.isEmpty(payload)) {
                this.eventBus.$emit('country-clicked', payload);
            }
        }
    }
}
</script>